/**
 * KYC ID document types. Server writes and validates against these values;
 * admin dashboard renders per-ID flows. Values match what ships on the wire
 * (all lowercase snake_case).
 */
export var AfriexIDType;
(function (AfriexIDType) {
    AfriexIDType["AlienCard"] = "alien_card";
    AfriexIDType["Bvn"] = "bvn";
    AfriexIDType["DriversLicense"] = "drivers_license";
    AfriexIDType["Itin"] = "itin";
    AfriexIDType["NationalId"] = "national_id";
    AfriexIDType["NationalIdNoPhoto"] = "national_id_no_photo";
    AfriexIDType["NewVoterId"] = "new_voter_id";
    AfriexIDType["Nin"] = "nin";
    AfriexIDType["NinSlip"] = "nin_slip";
    AfriexIDType["ResidencePermit"] = "residence_permit";
    AfriexIDType["Passport"] = "passport";
    AfriexIDType["PhoneNumber"] = "phone_number";
    AfriexIDType["Ssn"] = "ssn";
    AfriexIDType["SsnLast4"] = "ssn_last4";
    AfriexIDType["Ssnit"] = "ssnit";
    AfriexIDType["VoterId"] = "voter_id";
    AfriexIDType["VotersCard"] = "voters_card";
    AfriexIDType["TaxId"] = "tax_id";
})(AfriexIDType || (AfriexIDType = {}));
//# sourceMappingURL=AfriexIDType.js.map